import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addAnimationToSprite, MARBLE_DROP_ANIMATION } from '../AnimationManager';
import gameData from '../gameData';

export default class PenguinDropChar extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.xOffset = -45; // variable sheet from zoe

    this.vx = 0;
    this.vy = 0;
    this.destPoint = 60;

    this.speed = 200;

    this.penguin = this.scene.add.sprite(0,0, ABCyaPhaser.Images.DEFAULT_ATLAS);
    this.penguin.setFrame(MARBLE_DROP_ANIMATION.key + MARBLE_DROP_ANIMATION.animations.idle.frames[0].toString());
    addAnimationToSprite(this.penguin, MARBLE_DROP_ANIMATION, 'run', false);
    addAnimationToSprite(this.penguin, MARBLE_DROP_ANIMATION, 'dump', false);

    const basketshape = this.scene.add.rectangle(0,0, 80, 25, Phaser.Display.Color.GetColor(24, 155, 155)).setOrigin(0);

    this.basketHit = this.scene.add.container(); // Throw the shape in a container (should be able to use getBounds() but still have to set it)
    this.basketHit.add(basketshape);
    this.basketHit.x = this.xOffset * -1;
    this.basketHit.y = 15;
    this.basketHit.alpha = 0;
    this.add(this.basketHit);
    this.add(this.penguin);
    this.scene.sys.updateList.add(this.penguin); // bug fix for sprites in containers, they need re-added to the scene's update list

    this.basketContainer = this.scene.add.container();
    this.basketContainer.x = this.xOffset * -1;
    this.add(this.basketContainer);

    this.minX = -50;
    this.maxX = 890;
  }

  setVelocity (dir) {
    if (dir !== 0) {
      this.penguin.play('run', true);
    }
    else {
      this.penguin.stop();
      this.penguin.setFrame(MARBLE_DROP_ANIMATION.key + MARBLE_DROP_ANIMATION.animations.idle.frames[0].toString());
    }

    this.vx = this.speed * dir;
  }

  dropMarbles () {
    this.penguin.play('dump', true);
  }

  doRun () {
    this.penguin.play('run', true);
  }

  stopRun () {
    this.penguin.stop();
    this.penguin.setFrame(MARBLE_DROP_ANIMATION.key + MARBLE_DROP_ANIMATION.animations.idle.frames[0].toString());
  }

  tick (delta) {
    if (gameData.CONTROL_TYPE === 'keys') {
      if ((this.x > this.maxX && this.vx > 0) || (this.x < this.minX && this.vx < 0)) return;
      this.x += this.vx * (delta / 1000);
    }
    else {
      const dist = this.destPoint - this.x;
      const dir = dist > 0 ? 1 : -1;
      const vx = this.speed * dir * (delta / 1000);
      if (Math.abs(dist) > Math.abs(vx)) {
        this.x += vx;
        this.doRun();
      }
      else {
        this.x = this.destPoint;
        this.stopRun();
      }
    }
  }
}